import { RegistriaRequestCustomerDetails } from './registria-request-customer-details.interface';
import { RegistriaRequestRegisteredItem } from './registria-request-registered-item.interface';

export interface RegistriaUserRequest {
  registration: RegistriaRequestRegisteredItem;
  user: RegistriaRequestCustomerDetails;
}
